import React, { FunctionComponent, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Box, Button, TopBar } from 'plume-ui';
import useLoginWithOkta from '../hooks/useLoginWithOkta';
import FormattedMessage from '../../../utils/components/FormattedMessage';
import { DependencyContainer } from '../../../DependencyContainer';
import LoginContainerAuthError from '../components/LoginContainerAuthError';
import { BoxStyles } from 'plume-ui/dist/components/Box/Box';
import { useTranslation } from 'react-i18next';
import { useRedirectToRoute } from '../../../utils/hooks/useRedirectToRoute';
import { useTrackEvent } from '../../trackingAnalytics/hooks/useTrackEvent';
import { MixPanelEvents } from '../../../mixPanelEvents';
import { AvailableScreens } from '../../trackingAnalytics/types';

const { loginService } = new DependencyContainer();

const LoginContainer: FunctionComponent = () => {
  const { login, isAuthenticated } = useLoginWithOkta();
  const redirectToRoute = useRedirectToRoute();
  const authError = loginService.getAuthError();
  const { t } = useTranslation();
  const trackEvent = useTrackEvent();

  useEffect(() => {
    trackEvent({
      eventName: MixPanelEvents.SCREEN,
      additionalContent: {
        SCREEN: AvailableScreens.Login,
      },
    });
  }, []);

  if (isAuthenticated) {
    const targetRoute = loginService.getTargetRoute();
    redirectToRoute(targetRoute);
  }

  return (
    <>
      <Helmet>
        <title>{t('pageTitles.login')}</title>
      </Helmet>
      <TopBar />
      <div className="LoginContainer p-xl">
        <Box
          classes={(current: BoxStyles) => ({
            ...current,
            root: `${current.root} LoginContainer__box`,
          })}
        >
          <h3 className="LoginContainer__heading">
            <FormattedMessage id="signIn" />
          </h3>
          <h1 className="LoginContainer__app-name m-b-l m-t-s">
            <FormattedMessage id="appName" />
          </h1>
          {!!authError && <LoginContainerAuthError {...authError} />}
          <div className="LoginContainer__login-button">
            <Button styleVariant="superprimary" onClick={() => login()}>
              <FormattedMessage id="loginWithOkta" />
            </Button>
          </div>
        </Box>
      </div>
    </>
  );
};

export default LoginContainer;
